import { Link } from 'react-router-dom';
import { products } from '@/mocks/data';

export default function FeaturedProducts() {
  const featured = products.filter((p) => ['p1', 'p3', 'p5', 'p7']).concat(
    products.filter((p) => ['p9', 'p11'].includes(p.id))
  );

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              甄选推荐
            </h2>
            <p className="mt-2 text-foreground-500 text-sm md:text-base">
              编辑团队精心挑选的亚洲精品
            </p>
          </div>
          <Link
            to="/category/fashion"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5" data-product-shop>
          {featured.map((product) => (
            <Link
              key={product.id}
              to={`/category/${product.categoryId}`}
              className="group block bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={product.image}
                  alt={`${product.name} - ${product.brand} | 亚洲精品`}
                  title={`${product.name} - 亚洲精品推荐`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                {product.tag && (
                  <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-white text-xs rounded-full whitespace-nowrap">
                    {product.tag}
                  </span>
                )}
              </div>
              <div className="p-3">
                <p className="text-xs text-foreground-400 mb-1">{product.brand} · {product.origin}</p>
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200">
                  {product.name}
                </h3>
                <div className="flex items-center justify-between mt-2">
                  <span className="text-sm font-semibold text-accent-600 whitespace-nowrap">{product.price}</span>
                  <span className="flex items-center gap-0.5 text-xs text-foreground-400">
                    <i className="ri-star-fill w-3 h-3 flex items-center justify-center text-primary-400"></i>
                    {product.rating}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}